<template>
    <div class="container">
        <div class="paramForm">
            <el-form :model="params" label-width="90px">
                <el-row>
                    <el-form-item label="会员地址">
                        <el-input v-model="params.memberAddress" clearable  width="200px" class="param-address"></el-input>
                    </el-form-item>
                    <el-form-item label="结算ID">
                        <el-input v-model="params.profitId" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="释放日">
                        <el-date-picker v-model="params.createdAt" type="date" placeholder="选择释放日期"> </el-date-picker>
                    </el-form-item>
                </el-row>
            </el-form>
            <div class="paramFormButton">
                <el-button type="primary" icon="el-icon-search" @click="handleCurrentChange(1)">搜索</el-button>
                <el-button type="primary" @click="tokenReleaseTask" >执行释放</el-button>
            </div>
        </div>
        <div class="tableTool">
            <el-button type="primary" icon="el-icon-printer" @click="exportExcel">导出</el-button>
        </div>
        <el-table border ref="tableRef" id="out-table"  :data="tableData" class="table-show-current" highlight-current-row>
            <el-table-column align="center" prop="id" label="ALD奖励释放ID" width="150"></el-table-column>
            <el-table-column align="center" label="会员地址" width="150" class-name="address">
                <template slot-scope="scope" v-if="scope.row.memberAddress">
                    <span  v-clipboard:copy="scope.row.memberAddress" v-clipboard:success="onCopy">
                        {{scope.row.memberAddress.slice(0,5) + "..." + scope.row.memberAddress.slice(-5)}}<i class="el-icon-document-copy"/>
                    </span>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="profitId" label="ALD奖励结算ID" width="150"></el-table-column>
            <el-table-column align="center" label="释放日">
                <template slot-scope="scope">{{ formatDate2(new Date(scope.row.createdAt)) }}</template>
            </el-table-column>
            <el-table-column align="center" prop="timesNum" label="第几次释放">
                <template slot-scope="scope">{{ scope.row.timesNum == 0?'首次释放30%':"第"+scope.row.timesNum+"次" }}</template>
            </el-table-column>
            <el-table-column align="center" label="释放数量">
                <template slot-scope="scope">{{ toDecimalVal(scope.row.amount,4) }} ALD</template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination
                background
                layout="total,sizes, prev, pager, next"
                :current-page="pageInfo.pageNum"
                :page-size="pageInfo.pageSize"
                :page-sizes="[10, 20, 50, 100, 200]"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
import { aldServiceApi } from '@/api/api-ald';
import { exportData1,exportData2 } from '@/assets/js/exportExcel';
export default {
    data() {
        return {
            isSuper:false,
            params: {},
            total:0,
            pageInfo: {
                pageNum: 1,
                pageSize: 10
            },
            tableData:[],
        };
    },
    created() {
        this.isSuper = this.isSuperUser();
        if(!this.isSuper){
            this.params.leaderAddress = this.getUserName();
        }
        this.typeOptions = this.findDict("RWAS_PROFIT_TYPE");
        this.typeMap = this.listToMap(this.typeOptions,"code","name");
        this.handleSearch();
    },
    methods: {
        onCopy() {
            this.$message.success({message: "复制成功",duration: 600})
        },
        handleSizeChange(val) {
            this.pageInfo.pageSize = val;
            this.handleSearch();
        },
        handleCurrentChange(val) {
            this.pageInfo.pageNum = val;
            this.handleSearch();
        },
        handleSearch() {
            if(this.params.createdAt){
                this.params.createdAt = this.formatDate(new Date(this.params.createdAt))
            }
            aldServiceApi.findTokenReleasePageList(this.params,this.pageInfo).then(res => {
                this.tableData = res.records;
                this.total = res.total || 0;
            });
        },
        tokenReleaseTask(){
            aldServiceApi.tokenReleaseTask().then(res => {
                if (res.result) {
                    this.handleSearch()
                    this.$message.success("释放完成");
                } else {
                    if(res.msg){
                        this.$message.error(res.msg);
                    }else{
                        this.$message.error("释放失败");
                    }
                }
            });
        },
        exportExcel() {
            if(!this.isSuper){
                return;
            }
            if(!this.tableData || this.tableData.length==0){
                this.$message.warning({message: "没有可导出的数据",duration: 600})
                return;
            }
            let header = ['释放ID', '会员地址', '直推地址', '商户地址', '订单ID', '结算ID','结算日',"结算总额(RWAS)","结算总额(ETH)","释放日","线性释放","类型","释放数量(RWAS)","释放数量(ETH)"];
            let columns = ['id', 'memberAddress', 'parentAddress', 'leaderAddress', 'orderId','profitId', 'profitCreatedAt',"tokenTotal","ethTotal",'createdAt',"times",'type',"token","eth"];
            let data = this.tableData.map(r => columns.map(c => {
                if(c == 'createdAt' || c == 'profitCreatedAt'){
                    return this.formatDate2(new Date(r[c]));
                }else if(c == 'type'){
                    return this.typeMap[r[c]];
                }else{
                    let val = r[c];
                    if(typeof val === 'number'){
                        return this.toDecimalVal(val,10);
                    }
                    return val;
                }   
            }));
            exportData2(header,data,"释放记录");
        }
    }
};
</script>

<style lang='less' scope>
span.status_CANCEL{
    color:red;
}
span.status_CONFIRM{
    color:green;
}
span.status_PENDING{
    color:gray;
}
</style>